import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { SecureModule } from './secure/secure.module';
import { PublicModule } from './public/public.module';
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {TokenInterceptor} from "./interceptors/token.interceptor";
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';

//import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { LocationService } from './services/location.service';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    SecureModule,
    PublicModule,
    //SweetAlert2Module,
    NgxSmartModalModule.forRoot()
  ],
  providers: [ NgxSmartModalService, LocationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
